/** Shared bounds for municipal logos and embedded email images. */
export const EMBEDDED_PNG_MAX_BYTES = 100 * 1024;
export const EMBEDDED_PNG_MAX_DIMENSION = 800;

export function embeddedPngBytes(dataUrl) {
  if (typeof dataUrl !== 'string' || dataUrl.length > 4 * Math.ceil(EMBEDDED_PNG_MAX_BYTES / 3) + 22) return null;
  const content = dataUrl.match(/^data:image\/png;base64,((?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?)$/)?.[1];
  if (!content) return null;
  const bytes = content.length / 4 * 3 - (content.endsWith('==') ? 2 : content.endsWith('=') ? 1 : 0);
  return bytes <= EMBEDDED_PNG_MAX_BYTES ? bytes : null;
}
